import React, { useEffect, useState } from "react";
import { Building } from "lucide-react";

import BottomSheet from "../../app/BottomSheet";
import SearchInput from "src/components/app/SearchInput";
import Loader from "src/components/common/Loader";
import NoData from "src/components/app/NoData";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { getHospitalsListRequest } from "src/redux/slices/doctorsSlice";
import { Hospital } from "src/types/doctors.types";

interface HospitalsListBottomSheetProps {
  show: boolean;
  handleClose: () => void;
  onSelect: (hospital: Hospital) => void;
  cityId: string;
}

const HospitalsListBottomSheet: React.FC<HospitalsListBottomSheetProps> = ({
  show,
  handleClose,
  onSelect,
  cityId,
}) => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useAppDispatch();
  const { hospitalsList } = useAppSelector((state) => state.doctors);

  useEffect(() => {
    getHospitalsList();
  }, []);

  useEffect(() => {
    // if (debouncedSearchText) {
    getHospitalsList();
    // }
  }, [searchText]);

  const getHospitalsList = () => {
    try {
      const payload = {
        city_id: cityId,
        page: 1,
        search_param: searchText,
      };
      dispatch(
        getHospitalsListRequest({
          payload,
          resolve: () => {},
          reject: () => {},
        })
      );
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleSelect = (hospital: Hospital) => {
    onSelect(hospital);
    handleClose();
  };

  return (
    <BottomSheet show={show} title="Select Hospital" handleClose={handleClose}>
      <div className="flex flex-col p-4 gap-4">
        <SearchInput
          name="hospital"
          label="Hospital name"
          type="text"
          placeholder="Enter hospital name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div className="h-[300px] overflow-y-auto">
          {hospitalsList?.isLoading ? (
            <div className="flex justify-center items-center h-full">
              <Loader size="lg" color="primary" />
            </div>
          ) : hospitalsList?.data?.length > 0 ? (
            hospitalsList?.data?.map((hospital) => (
              <button
                key={hospital?.clinic_master_id}
                className="w-full px-4 py-2 hover:bg-gray-50 text-left text-md text-gray-700 border-b border-gray-200"
                onClick={() => handleSelect(hospital)}
              >
                {hospital?.clinic_name}
              </button>
            ))
          ) : hospitalsList?.data?.length === 0 && !hospitalsList?.isLoading ? (
            <NoData
              icon={<Building />}
              title="No hospitals found"
              className="pb-8"
            />
          ) : null}
        </div>
      </div>
    </BottomSheet>
  );
};

export default HospitalsListBottomSheet;
